export class RPCError extends Error {
	statusCode: number
	content: { [key: string]: any } | null
	constructor(message: string, statusCode: number, content: Object | null = null) {
		super(message)
		this.statusCode = statusCode
		this.content = content
	}
}
